import { Controller } from "@hotwired/stimulus"

const NATIVE_PROMPT_DELAY_MS = 1500

// The iOS app (1.2.1+) shows Apple's own rating prompt, which people rate in
// without leaving the app. Apple may decline to show it, so it isn't tied to
// a button tap: it's asked for once the Kitchen settles, and the card stays
// hidden. Older apps show the card, whose link opens the App Store — record
// the ask on the way out and take the card away; the link is left to navigate.
export default class extends Controller {
  static values = { url: String }

  connect() {
    if (this.nativePrompt) {
      this.timer = setTimeout(() => this.askNatively(), NATIVE_PROMPT_DELAY_MS)
    } else {
      this.element.hidden = false
    }
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  rated() {
    this.recordAsk()
  }

  askNatively() {
    this.nativePrompt.postMessage({})
    this.recordAsk()
  }

  recordAsk() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.urlValue, {
      method: "DELETE",
      headers: { "X-CSRF-Token": token, "Accept": "text/vnd.turbo-stream.html" },
      credentials: "same-origin",
      keepalive: true
    }).catch(() => { /* the card is gone either way; the next visit asks again */ })
    this.element.remove()
  }

  get nativePrompt() {
    return window.webkit?.messageHandlers?.requestReview
  }
}
